import request from '@/utils/request'

export function changeAddress(data) {
  return request({
    url: '/staking/changeAddress',
    method: 'post',
    data,
  })
}


export function getValidatorAPY(data) {
  return request({
    url: '/staking/apy',
    method: 'get',
    params: {
      moniker: data,
      t:Math.ceil(Math.random()*1000000)
    },
  })
}

///staking/getPubKey
export function stepOne(data) {
  return request({
    url: '/staking/signDatatoHex',
    method: 'post',
    data,
  })
}

export function stepTwo(data) {
  return request({
    url: '/staking/getPubKey',
    method: 'post',
    data,
  })
}

export function stepThree(data) {
  return request({
    url: '/staking/getSignData',
    method: 'post',
    data,
  })
}

export function stepFour(data) {
  return request({
    url: '/staking/boardcastTrans',
    method: 'post',
    data,
  })
}


export function getNowTime() {
  return request({
    url: `${requestPrefix}/contractTAT.json`,
    method: 'get',
    params: {
      time: time
    },
    vconfig: {
      noBaseApi: true,
      noErr: true
    },
    responseType: "application/json"

  })
}

